import styled from "styled-components"

export const DescriptionWrapper = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 95px 0 0;

    @media screen and (max-width: 768px){
        margin: 45px 0 0;
        align-items: normal;
    }
`;

export const DescriptionH1 = styled.h1`
    color: var(--white);
    font-style: normal;
    font-weight: 900;
    font-size: 64px;
    line-height: 93px;
    width: 100%;
    max-width: 1189px;
    margin-bottom: 34px;
    text-align: center;

    @media screen and (min-width: 1201px) and (max-width: 1280px){
        font-size: 54px;
        line-height: 81px;
    }

    @media screen and (min-width: 1125px) and (max-width: 1200px){
        font-size: 50px;
        line-height: 76px;
        max-width: 1000px;
    }

    @media screen and (min-width: 1024px) and (max-width: 1124px){
        font-size: 44px;
        line-height: 70px;
    }

    @media screen and (min-width: 769px) and (max-width: 1023px) {
        font-size: 23px;
        line-height: 33.58px;
        margin-bottom: 24px;
    }

    @media screen and (max-width: 768px){
        font-size: 23px;
        line-height: 34px;
        margin-bottom: 24px;
    }
`;

export const DescriptionP = styled.p`
    color: var(--gray3);
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 39px;
    text-align: center;
    width: 100%;
    max-width: 1005px;

    @media screen and (min-width: 1024px) and (max-width: 1124px){
        font-size: 20px;
        line-height: 35px;
    }

    @media screen and (min-width: 768px) and (max-width: 1023px) {
        font-size: 16px;
        line-height: 22px;
    }

    @media screen and (max-width: 767px){
        font-size: 12px;
        line-height: 20px;
    }
`;

export const WebWrap = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 181px;

    @media screen and (min-width: 769px) and (max-width: 1023px) {
        margin-top: 50px;
    }

    @media screen and (max-width: 768px){
        margin-top: 44px;
    }

`;

export const DescriptionScan = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 28px;
    width: 323px;
    height: 119px;
    border: 3px solid var(--white);
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(4px);

    @media screen and (max-width: 768px){
        display: none;
    }
`;

export const DescriptionScanP = styled.p`
    color: var(--white);
    font-style: normal;
    font-size: 18px;
    line-height: 28.35px;
    font-weight: bold;
    text-align: right;
`;

export const Barcode = styled.img`
    width: 79px;
    height: 79px
`;

export const DescriptionApp = styled.div`
    display: none;

    @media screen and (min-width: 769px) and (max-width: 1023px) {
        margin-top: 50px;
    }

    @media screen and (min-width: 501px) and (max-width: 768px) {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        margin-top: 50px;
    }

    @media screen and (max-width: 500px){
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        margin-top: 50px;
    }
`;

export const DescriptionImg = styled.img`
    width: 139px;
    height: 60px;
`;

export const DescriptionSm = styled.img`
    margin-top: 154px;
    width: 745.4px;
    height: 745.4px;

    @media screen and (min-width: 769px) and (max-width: 1023px) {
        margin-top: 100px;
        width: 422.52px;
        height: 422.52px;
    }

    @media screen and (max-width: 768px){
        margin-top: 56px;
        width: 322.52px;
        height: 322.52px;
    }

`;